import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { usePowerDialerPageContext } from 'pages/powerDialer/context/powerDialerPageContext'
import { PowerDialerViewStore } from 'pages/powerDialer/pages/view/store/powerDialerViewStore'
import { useEventViewPowerDialerUpdated } from 'pages/powerDialer/pages/view/events/EventViewPowerDialerUpdated'

const PowerDialerViewContext = createContext<PowerDialerViewStore | null>(null)

export const usePowerDialerViewContext = () => {
  const context = useContext(PowerDialerViewContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with PowerDialerViewContext')

  return context
}

export const PowerDialerViewProvider = ({ children }: PropsWithChildren) => {
  const { id } = useParams()
  const entities = useEntitiesContext()
  const { pageLayoutStore } = usePowerDialerPageContext()
  const store = useMemo(() => new PowerDialerViewStore(id, pageLayoutStore, entities), [])

  useEventViewPowerDialerUpdated(store)

  useEffect(() => {
    store.init()

    return () => store.dispose()
  }, [])

  return <PowerDialerViewContext.Provider value={store}>{children}</PowerDialerViewContext.Provider>
}
